import { isObject } from "lodash";
import type { Query } from "@tanstack/react-query";
import type { TaskEntityType } from "./tasksApi";

const TASKS_QUERY_KEY_PREFIX = "tasks";

export function taskQueryKey(showCompleted: boolean) {
  return [TASKS_QUERY_KEY_PREFIX, { showCompleted }];
}

export function entityTaskQueryKey(entityType: TaskEntityType, entityId: string) {
  return [TASKS_QUERY_KEY_PREFIX, entityType, entityId];
}

export function isTasksQueryKey({ queryKey }: Query) {
  return queryKey.length === 2 && queryKey[0] === TASKS_QUERY_KEY_PREFIX && isObject(queryKey[1]);
}
